import { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    file: "File",
    newProject: "New Project",
    loadDemo: "Load Demo",
    save: "Save",
    exportGif: "Export GIF",
    exportMp4: "Export MP4",
    export: "Export",
    selectObject: "Select an object",
    position: "Position",
    size: "Size",
    scale: "Scale",
    appearance: "Appearance",
    keyframe: "Keyframe",
    addKeyframe: "Add Keyframe",
    keyframeAt: "Keyframe @",
    keyframes: "keyframes",
    timeline: "Timeline",
    tools: "Tools",
    select: "Select",
    move: "Move",
    rectangle: "Rectangle",
    circle: "Circle",
    star: "Star",
    text: "Text",
    pen: "Pen",
    addBatelka: "Add Batelka",
    addEllipse: "Add Ellipse",
    presets: "Presets",
    projects: "Projects",
    noProjects: "No saved projects",
    load: "Load",
    delete: "Delete",
    savedProjects: "Saved Projects",
    animPresets: "Animation Presets",
    bounce: "Bounce",
    fadeIn: "Fade In",
    fadeOut: "Fade Out",
    spin: "Spin 360",
    pulse: "Pulse",
    slideIn: "Slide In",
    applyPreset: "Apply to selected",
    exporting: "Exporting...",
    exportDone: "Export complete!",
    exportFail: "Export failed",
    capturingFrames: "Capturing frames",
    uploading: "Uploading",
    encoding: "Encoding",
    quality: "Quality",
    qualityFull: "Full",
    qualityHigh: "High",
    qualityMedium: "Medium",
    qualityFast: "Fast",
    clipDuration: "Clip duration",
    resolution: "Resolution",
    exportDuration: "Clip duration",
    originalSpeed: "Original speed",
    faster: "faster",
    slower: "slower",
    text: "Text",
    enterText: "Enter text...",
    projectSaved: "Project saved",
    projectLoaded: "Project loaded",
    projectDeleted: "Project deleted",
    newProjectCreated: "New project created",
    demoLoaded: "Demo loaded",
    fps: "FPS",
    frame: "Frame",
    time: "Time",
    layers: "Layers",
    zoom: "Zoom",
    drawMode: "Drawing mode",
    clickToFinish: "Click to finish",
    easing: "Easing",
    easingHint: "Interpolation between keyframes",
    easing_linear: "Linear",
    easing_easeIn: "Ease In",
    easing_easeOut: "Ease Out",
    easing_easeInOut: "Ease In-Out",
    easing_easeInCubic: "Ease In Cubic",
    easing_easeOutCubic: "Ease Out Cubic",
    easing_easeInOutCubic: "Ease In-Out Cubic",
    easing_bounce: "Bounce",
    easing_elastic: "Elastic",
    objectLibrary: "Object Library",
    objectLibraryHint: "Click to add object to canvas",
    libCat_shapes: "Basic Shapes",
    libCat_decorations: "Decorations",
    libCat_ballet: "Ballet & Stage",
    rectangle: "Rectangle",
    circle: "Circle",
    ellipse: "Ellipse",
    triangle: "Triangle",
    hexagon: "Hexagon",
    diamond: "Diamond",
    pentagon: "Pentagon",
    heart: "Heart",
    arrowRight: "Arrow Right",
    arrowUp: "Arrow Up",
    lightning: "Lightning",
    cloud: "Cloud",
    flower: "Flower",
    musicNote: "Music Note",
    spotlight: "Spotlight",
    curtainLeft: "Curtain Left",
    curtainRight: "Curtain Right",
    stageFloor: "Stage Floor",
    sparkle: "Sparkle",
    addAgata: "Add Agata",
    addBlondeBallerina: "Add Blonde Ballerina",
    addSun: "Add Sun",
    addSinger: "Add Singer",
    characterEditor: "Character Editor",
    characterEditorHint: "Customize character colors and appearance",
    selectCharacterFirst: "Select a character on canvas first",
    editColors: "Edit Colors",
    charBody: "Body",
    charHair: "Hair",
    charSkin: "Skin",
    charDress: "Dress / Clothing",
    charShoes: "Shoes",
    charEyes: "Eyes",
    charClothing: "Clothing / Top",
    charAccessory: "Accessory",
    charDetail1: "Detail 1 (Yellow)",
    charDetail2: "Detail 2 (Orange)",
  },
  cs: {
    file: "Soubor",
    newProject: "Novy projekt",
    loadDemo: "Nacist demo",
    save: "Ulozit",
    exportGif: "Export GIF",
    exportMp4: "Export MP4",
    export: "Export",
    selectObject: "Vyberte objekt",
    position: "Pozice",
    size: "Velikost",
    scale: "Meritko",
    appearance: "Vzhled",
    keyframe: "Keyframe",
    addKeyframe: "Pridat keyframe",
    keyframeAt: "Keyframe @",
    keyframes: "keyframes",
    timeline: "Casova osa",
    tools: "Nastroje",
    select: "Vybrat",
    move: "Presunout",
    rectangle: "Obdelnik",
    circle: "Kruh",
    star: "Hvezda",
    text: "Text",
    pen: "Pero",
    addBatelka: "Pridat Batelku",
    addEllipse: "Pridat elipsu",
    presets: "Presety",
    projects: "Projekty",
    noProjects: "Zadne ulozene projekty",
    load: "Nacist",
    delete: "Smazat",
    savedProjects: "Ulozene projekty",
    animPresets: "Animacni presety",
    bounce: "Odraz",
    fadeIn: "Rozjasnit",
    fadeOut: "Ztmavit",
    spin: "Otoceni 360",
    pulse: "Pulzovani",
    slideIn: "Prijet",
    applyPreset: "Pouzit na vybrany",
    exporting: "Exportuji...",
    exportDone: "Export hotov!",
    exportFail: "Export selhal",
    capturingFrames: "Zachytavam snimky",
    uploading: "Nahravani",
    encoding: "Kodovani",
    quality: "Kvalita",
    qualityFull: "Plna",
    qualityHigh: "Vysoka",
    qualityMedium: "Stredni",
    qualityFast: "Rychla",
    clipDuration: "Delka klipu",
    resolution: "Rozliseni",
    exportDuration: "Delka klipu",
    originalSpeed: "Originalni rychlost",
    faster: "rychleji",
    slower: "pomaleji",
    text: "Text",
    enterText: "Zadejte text...",
    projectSaved: "Projekt ulozen",
    projectLoaded: "Projekt nacten",
    projectDeleted: "Projekt smazan",
    newProjectCreated: "Novy projekt vytvoren",
    demoLoaded: "Demo nacteno",
    fps: "FPS",
    frame: "Snimek",
    time: "Cas",
    layers: "Vrstvy",
    zoom: "Zoom",
    drawMode: "Rezim kresleni",
    clickToFinish: "Kliknete pro dokonceni",
    easing: "Prubeh",
    easingHint: "Interpolace mezi keyframes",
    easing_linear: "Linearni",
    easing_easeIn: "Zpomalit zacatek",
    easing_easeOut: "Zpomalit konec",
    easing_easeInOut: "Plynuly prechod",
    easing_easeInCubic: "Kubicky zacatek",
    easing_easeOutCubic: "Kubicky konec",
    easing_easeInOutCubic: "Kubicky prechod",
    easing_bounce: "Odraz",
    easing_elastic: "Pruzny",
    objectLibrary: "Knihovna objektu",
    objectLibraryHint: "Kliknete pro vlozeni objektu na platno",
    libCat_shapes: "Zakladni tvary",
    libCat_decorations: "Dekorace",
    libCat_ballet: "Balet a scena",
    rectangle: "Obdelnik",
    circle: "Kruh",
    ellipse: "Elipsa",
    triangle: "Trojuhelnik",
    hexagon: "Sestiuhelnik",
    diamond: "Diamant",
    pentagon: "Petiuhelnik",
    heart: "Srdce",
    arrowRight: "Sipka vpravo",
    arrowUp: "Sipka nahoru",
    lightning: "Blesk",
    cloud: "Mrak",
    flower: "Kvetina",
    musicNote: "Nota",
    spotlight: "Reflektor",
    curtainLeft: "Opona leva",
    curtainRight: "Opona prava",
    stageFloor: "Podium",
    sparkle: "Jiskra",
    addAgata: "Pridat Agatu",
    addBlondeBallerina: "Pridat Blond Baletku",
    addSun: "Pridat Slunicko",
    addSinger: "Pridat Zpevacku",
    characterEditor: "Editor postav",
    characterEditorHint: "Upravte barvy a vzhled postavy",
    selectCharacterFirst: "Nejprve vyberte postavu na platne",
    editColors: "Upravit barvy",
    charBody: "Telo",
    charHair: "Vlasy",
    charSkin: "Kuze",
    charDress: "Saty / Obleceni",
    charShoes: "Boty",
    charEyes: "Oci",
    charClothing: "Obleceni / Top",
    charAccessory: "Doplnek",
    charDetail1: "Detail 1 (Zluty)",
    charDetail2: "Detail 2 (Oranzovy)",
  }
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState('cs');
  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be inside I18nProvider');
  return ctx;
}
